<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import ActionMenuDropdown from "@/components/ActionMenu/ActionMenuDropdown.vue";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import MirrorSticky from "@/components/menu/MirrorSticky/MirrorSticky.vue";
import { injectStrict } from "@/utils/vue";

import { isActionVisible, isStickyMirrorable } from "../actions";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const isVisible = computed(() => {
  const isVisible = isActionVisible("mirror", card, board.value);
  const isMirrorable = isStickyMirrorable(card);
  return isVisible && isMirrorable;
});
</script>

<template>
  <ActionMenuDropdown v-if="isVisible" :action="cardActions.mirror" width="lg">
    <MirrorSticky />
  </ActionMenuDropdown>
</template>
